
    import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
    import { mapActions, mapGetters, mapState } from 'vuex';
    import { CompareFunction, DataTableHeaders } from '@/types';
    import OffeneVerrechnungRow from '@/types/OffeneVerrechnung';

    @Component({
        computed: {
            ...mapGetters('authentication', ['impfstelleDetail']),
            ...mapState('statistik', ['loaders', 'verrechnungen']),
            ...mapState('globals', ['sortDate']),
        },
        methods: {
            ...mapActions('statistik', ['loadOffeneVerrechnung', 'exportOffeneVerrechnung']),
            ...mapActions('session', ['setSelectedVerrechnung']),
            ...mapActions('patient', ['loadPatient']),
        },
    })
    export default class OffeneVerrechnung extends Vue {
        @Prop() visible!: boolean;

        public sortDate!: CompareFunction<OffeneVerrechnungRow>;
        public loadOffeneVerrechnung!: () => void;
        public loadPatient!: (payload: { patnr: number }) => Promise<void>;

        public search = '';

        public get headers(): DataTableHeaders<OffeneVerrechnungRow> {
            return [
                { value: 'Impfdatum', text: 'Datum', sort: this.sortDate, },
                { value: 'nachname', text: 'Nachname' },
                { value: 'vorname', text: 'Vorname' },
                { value: 'Geburtsdatum', text: 'Geburtsdatum', sort: this.sortDate, },
                { value: 'textDisplay', text: 'Impfstoff / Leistung / Untersuchung' },
                { value: 'actions', text: '', sortable: false },
            ];
        }

        @Watch('visible')
        public onChangeVisible(visible: boolean): void {
            if (visible) {
                this.loadOffeneVerrechnung();
            }
        }

        public onClickPatient(item: OffeneVerrechnungRow): void {
            this.$emit('close');

            if (this.$router.currentRoute.path !== '/') {
                this.$router.push('/');
            }

            this.loadPatient({ patnr: item.patnr as number });
        }
    }
